import { getCategory } from '../ducks';
import { useSelector } from 'react-redux';

export const useGetCategoryData = () => ({
  categoryData: useSelector(getCategory),
});
